module.exports = __webpack_public_path__ + "static/media/wide.397e0b55.jpg";